import React from 'react';

const Popup = ({ children, className, show }) => (
        <div className={`${className || ''} ${show ? '' : 'hidden'} top-full inset-x p-2 bg-white absolute shadow-lg`}>
          {children}
        </div>
);

export default Popup;
